import React, { useMemo } from 'react';
import TopNavigation from 'theme/TopNavigation';
import Text from "theme/Text";
import { useNavigation } from "@react-navigation/native";
import { StyleSheet, View } from "react-native";
import _ from 'lodash';
import { topNavigationProps } from "styles/top-navigation";
import { textProps } from "styles/text";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import DrawerHamburger from "components/atoms/DrawerHamburger";
import NavigationButton from "components/atoms/NavigationButton";
import HelperPlatform from "utils/helper-platform";
import { TESTID } from '_shared/config/testID';
import { ThemedTopNavigationStyles } from 'styles/components/atoms/ThemedTopNavigation'
import Icon from 'components/atoms/Icon'
import { IconSystemConstants } from 'utils/constants/IconNameConstants'
import isEqual from 'react-fast-compare'
import { colorList } from 'utils/colors'
import VStack from 'components/atoms/stack/VStack'
import { AppRoutes } from 'navigations/app-routes';

const ThemedTopNavigation = ({ showBackButton = false, showHamburgerDrawer = false, accessoryRight, tabbar = null, title, subtitle, backgroundColor = 'transparent' }) => {
	
	const navigation = useNavigation();
	const insets = useSafeAreaInsets();
	
	const viewStyle = {
		backgroundColor: backgroundColor,
		paddingTop: _.get( insets, 'top', 0 )
	}
	
	const accessoriesLeftViewStyle = HelperPlatform.select({
		web: {
			...StyleSheet.flatten( ThemedTopNavigationStyles.accessoryWeb ),
			...StyleSheet.flatten( ThemedTopNavigationStyles.accessoryLeftWeb )
		},
		default: {
			...StyleSheet.flatten( ThemedTopNavigationStyles.accessory ),
			...StyleSheet.flatten( ThemedTopNavigationStyles.accessoryLeft )
		}
	})
	
	const accessoriesRightViewStyle = HelperPlatform.select({
		web: {
			...StyleSheet.flatten( ThemedTopNavigationStyles.accessoryWeb ),
			...StyleSheet.flatten( ThemedTopNavigationStyles.accessoryRightWeb )
		},
		default: {
			...StyleSheet.flatten( ThemedTopNavigationStyles.accessory ),
			...StyleSheet.flatten( ThemedTopNavigationStyles.accessoryRight )
		}
	})

	const titleViewContainerStyle = HelperPlatform.select({
		web: {
			...StyleSheet.flatten( ThemedTopNavigationStyles.containerWeb )
		},
		default: {
			...StyleSheet.flatten( ThemedTopNavigationStyles.container )
		}
	})
	
	const titleTextViewStyle = HelperPlatform.select({
		web: {
			...StyleSheet.flatten( ThemedTopNavigationStyles.titleViewWeb )
		},
		default: {
			...StyleSheet.flatten( ThemedTopNavigationStyles.titleView )
		}
	})
	
	const navigateBackAccessoryStyle = [
		topNavigationProps.icon,
		staticStyles.navigateBackAccessoryStyleFontSize20WidthAuto
	]
	
	const navigateBack = () => {
		if( navigation.canGoBack() ) {
			navigation.goBack();
		} else {
			navigation.reset({
				index: 0,
				routes: [
					{
						name: AppRoutes.TAB_TODAY,
					}
				]
			})
		}
	};
	
	let navTitle = '';
	if( title ) {
		navTitle = title;
	}
	
	// Accessory left
	const navAccessoryLeft = useMemo( () => {
		if( showHamburgerDrawer ) {
			return (
				<DrawerHamburger
					navigation={ navigation }
				/>
			)
		}
		
		if( showBackButton ) {
			return (
				<NavigationButton
					onPress={ navigateBack }
					testID={ TESTID.INTERFACE.BACK_BUTTON }
					accessoryLeft={ () => {
						return (
							<Icon
								icon={ IconSystemConstants.ARROW_LEFT }
								style={ navigateBackAccessoryStyle }
							/>
						);
					}}
				/>
			)
		}
		
		return null
	}, [ showHamburgerDrawer, showBackButton ])
	
	// Accessory right
	const navAccessoryRight = useMemo( () => {
		if( _.isFunction( accessoryRight ) ) {
			return accessoryRight();
		}
		
		if( accessoryRight ) {
			return accessoryRight
		}
		
		return null
	}, [ accessoryRight ] )
	
	return (
		<View
			style={[ ThemedTopNavigationStyles.topNavigationContainer, viewStyle ]}>
			
			<TopNavigation
				alignment="center"
				style={ ThemedTopNavigationStyles.topNavigation }>

				<View
					style={ titleViewContainerStyle }>
					
					{/* Left button */}
					<View
						style={ accessoriesLeftViewStyle }>
						
						{ navAccessoryLeft }
					</View>
					
					{/* Center text */}
					<VStack
						space={ 0 }
						style={ titleTextViewStyle }>
						
						<Text
							{ ...textProps.fit }
							style={ ThemedTopNavigationStyles.title }>
							
							{ navTitle }
						</Text>
						
						{ ( _.size( subtitle ) > 0 ) && (
							<Text
								style={ ThemedTopNavigationStyles.subtitle }>
								
								{ subtitle }
							</Text>
						)}
					</VStack>
					
					{/* Right button */}
					<View
						style={ accessoriesRightViewStyle }>
						
						{ navAccessoryRight }
					</View>
				</View>
			</TopNavigation>
			
			{ tabbar }
		</View>
	);
}

const staticStyles = StyleSheet.create({
	navigateBackAccessoryStyleFontSize20WidthAuto: {
		fontSize: 20,
		width: 'auto',
		height: 'auto',
		color: colorList.TITLE.primary,
	},
});

export default React.memo( ThemedTopNavigation, isEqual );
